import React from 'react';
import createReactClass from 'create-react-class';

//Style
import Grid from '@material-ui/core/Grid';
import {Card} from 'material-ui/Card';
import Paper from '@material-ui/core/Paper';

//Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

//Forms

import FormLabel from '@material-ui/core/FormLabel';

//TextField
import TextField from 'material-ui/TextField';

//Loader Button
import LoaderButton from "../../components/LoaderButton";
// Event Window
import EventView from "./eventView";
//Video Topic Window
import VideoTopicSelect from "./videoTopicView";
//Video Language Window
import VideoLanguageSelect from "./videoLanguageView";
//Video Country Window
import VideoCountrySelect from "./videoCountryView";
//Organization Window
import OrganizationSelect from "./organizationView";
//Userdevice Window
import UserSelect from "./userView";
//Coordinate Window
import CoordinateSelect from "./coordinateView";
//Map Window
import GoogleMapsContainer from "./map/googleMap";


//API
import { API } from "aws-amplify";
import config from "../../config";

//Data Table components
import DataTables from 'material-ui-datatables';
//Export to Excel
import {CSVLink} from 'react-csv';

import Workbook from 'react-excel-workbook'
import { isString } from 'util';

//Charts
//Bar Graph
import BarGraph from "./graphs/bar";
//Line Graph
import LineGraph from "./graphs/line";
//Pie Graph
import PieGraph from "./graphs/pie";
//Scatter Graph
import ScatterGraph from "./graphs/scatter";


const TABLE_COLUMNS = require('./columnCustomization');
const dateConverter = require('./unixToDateConverter');


var dateFormat = require('dateformat/lib/dateformat');
var currentTime = new Date();
currentTime= dateFormat(currentTime, "mmm dd yyyy HH:MM:ss");

var graphArray=[];
var counter=0;

const styles = {
  tableStyle: {
    tableLayout: 'auto',
  },
  tableBodyStyle: {
    overflowX: 'auto',
  },
  tableWrapperStyle: {
    padding: 5,
  },
  header:{
    textAlign:'center',
     marginTop:40,
     fontSize: 32,
     marginBottom:40,
     marginLeft:20
     }
};

//FromDate
  var FromDate = createReactClass({
    getInitialState: function() {
        return {
             fromDate:'yyyy-MM-dd'
        }    
    },
    handleFromDateFieldChange: function(event)  {
        this.setState({fromDate: event.target.value});
        var fromDate = event.target.value;
        this.props.onChange(fromDate);

      },
      reset(event) {

        this.setState({  
          fromDate:''
      });
      this.props.onChange('');  

    },
    render: function() {
      return (
          
        <div>

              <TextField
                  id="fromDate"
                  floatingLabelText="From Date"
                  type="date" 
                  value={this.state.fromDate}
                  onChange={this.handleFromDateFieldChange}
                  style={{marginLeft: 1}}
                  inputStyle={{ fontSize: '1.2rem' }}
                  floatingLabelFixed={true} 
                />
              <Button size="small" color="primary" onClick={ this.reset} style={{marginLeft:10}}>
                Reset
              </Button>
      </div>
      );
    },
  });

  //ToDate
  var ToDate = createReactClass({
    getInitialState: function() {
        return {
             toDate:'yyyy-MM-dd'
        }    
    },
    handleToDateFieldChange: function(event) {
        this.setState({toDate: event.target.value});
        var toDate= event.target.value;
        this.props.onChange(toDate);

      },
      reset(event) {

        this.setState({  
          toDate:''
      });
      this.props.onChange('');  

    },
    render: function() {
      return (
          
        <div>

               <TextField
                  id="toDate"
                  floatingLabelText="To Date"
                  type="date"
                  value={this.state.toDate}
                  onChange={this.handleToDateFieldChange}
                  style={{marginLeft: 1}}
                  inputStyle={{ fontSize: '1.2rem' }}
                  floatingLabelFixed={true} 
                />      
              <Button size="small" color="primary" onClick={ this.reset} style={{marginLeft:10}}>
                Reset
              </Button>

      </div>
      );
    },
  });  


//Activity View
  var ActivityView = createReactClass({
    
    // safePushLatLng: function(item, targetArray) {
    //   const lat = parseFloat(item.where_shareEventLog[0]);
    //   const lng = parseFloat(item.where_shareEventLog[1]);
    //   if (!isNaN(lat) && !isNaN(lng)) {
    //     item.where_shareEventLog[0] = lat;
    //     item.where_shareEventLog[1] = lng;
    //     targetArray.push(item);
    //   }
    // },

    safePushLatLng(item, targetArray) {
      let lat = parseFloat(item.where_shareEventLog[0]);
      let lng = parseFloat(item.where_shareEventLog[1]);
    
      if (isNaN(lat) || isNaN(lng)) return;
    
      // Fix for known countries that store reversed coordinates
      const reverseCountries = ["Ghana", "Barbados", "Ethiopia", "Togo", "Benin", "Bolivia", "Bosnia and Herzegovina", "Brazil", "Burkina Faso", "Cabo Verde", "Canada", "Columbia", "Côte d'Ivoire", "Cuba (Guantánamo)", "Guinea-Bissau", "Laos", "Liberia", "Malaysia", "Mali", "Mauritania", "Moldova", "Morocco", "Phillippines", "Senegal", "Sierra Leone", "South Sudan", "Spain", "Togo", "Tonga", "United States", "USA", "Venezuela", "Vietnam"]; // Add more as needed
    
      if (reverseCountries.includes(item.country)) {
        // Swap latitude and longitude
        const temp = lat;
        lat = lng;
        lng = temp;
      }
    
      item.where_shareEventLog[0] = lat;
      item.where_shareEventLog[1] = lng;
    
      targetArray.push(item);
    },

    getInitialState: function() {
        return {
          eventQuery: { 
            eventName: '',            
            fromDate:null,
            toDate:null,
            },
            videoQuery:{
              topic:'',
              language:'',
              country:'',
              fromDate:null,
              toDate:null,
            },
            organizationQuery:{
              organization:'',
              fromDate:null,
              toDate:null,
            },
            userQuery:{
              userdevice:'',
              fromDate:null,
              toDate:null,
            },
            locationQuery:{
              fromLatitude:'',
              toLatitude:'',
              fromLongitude:'',
              toLongitude:'',
              fromDate:null,
              toDate:null,
            },
            dateQuery:{
              fromDate:'',
              toDate:'',
            },
            fileType:'',
            loading: false,
            dataChange:'',
            activities:[],
            filteredItems: [],
            fromDate:null,
            toDate:null,
            open: false,
            reset:false,
            editField:false,
            disableButton:false,
            eventChanged:false,
            topicChanged:false,
            languageChanged:false,
            countryChanged:false,
            locationChanged:false,
            organizationChanged:false,
            userChanged:false,
            saveClicked:false,
            dateReset:false,
            multiParam:false,
            bargraph:false,
            linegraph:false,
            piegraph:false,
            scattergraph:false,
            countData:[],
            tmpPie:[],
            options: {
              chart: {
                stacked: true,
                toolbar: {
                  show: true,
                  tools: {
                    download: false,
                    selection: false,
                    zoom: false,
                    zoomin: true,
                    zoomout: true,
                    pan: false,
                    reset: true
                  },
                },
            },
              series: [],
              xaxis: {
                categories:[],
                type: 'datetime'
                },
              fill: {
                  opacity: 1
              },       
              legend: {
                  position: 'top',
                  verticalAlign: 'top',
                  offsetX: 0,
                  offsetY: 0
              }
        },
        pieOptions:{
          labels:[],
          series:[]
      }
        }    
    },
    //Handle Selecting an Event
    handleEventChange: function(eventVal) {
      // const newObject = this.state.eventQuery;
      if(!eventVal)
      {
        var newObject=[];

        newObject = this.state.eventQuery;
        newObject.eventName= eventVal;


        this.setState({eventQuery: newObject, activities:[], eventChanged:false,saveClicked:false});

        if((this.state.toDate!=null || this.state.fromDate!=null))
       {
        this.setState({saveClicked:false});
        this.setState({dateReset:true});
        }
      }
      else
      {

          if(!this.state.eventQuery.eventName)
          {
            this.state.eventQuery.eventName= eventVal;
          }
          else
            this.state.eventQuery.eventName=this.state.eventQuery.eventName.concat(','+eventVal);      

          this.setState({eventChanged:true});

    }

    },
    //Handle Selecting FromDate
    handleFromDateFieldChange: function(fromDateVal) {    

      var newObject=[];
      if(fromDateVal.length===0)
      {
        this.setState({fromDate:null,
          activities:[]});
      }
      else{
          this.state.fromDate = new Date(fromDateVal).getTime()/ 1000;
          this.state.fromDate = this.state.fromDate/60/60/24;
      

          if(!!this.state.eventQuery.eventName)
            {
              newObject = this.state.eventQuery;
              newObject.fromDate= this.state.fromDate;
              this.setState({eventQuery: newObject});
            }
            else if(!!this.state.videoQuery.topic || !!this.state.videoQuery.language || !!this.state.videoQuery.country)
            {         
              newObject = this.state.videoQuery;
              newObject.fromDate= this.state.fromDate;
             
              this.setState({videoQuery: newObject});
            }
            else if(!!this.state.organizationQuery.organization )
            {
              newObject = this.state.organizationQuery;
              newObject.fromDate= this.state.fromDate;

              this.setState({organizationQuery: newObject});
            }
            else if(!!this.state.userQuery.userdevice )
            {
              newObject = this.state.userQuery;
              newObject.fromDate= this.state.fromDate;

              this.setState({userQuery: newObject});
            }
            else if(!!this.state.locationQuery.fromLatitude ||!!this.state.locationQuery.toLatitude
              ||!!this.state.locationQuery.toLongitude || !!this.state.locationQuery.fromLongitude)
            {
              newObject = this.state.locationQuery;
              newObject.fromDate= this.state.fromDate;
            
              this.setState({locationQuery: newObject});
            }
            else{
              newObject = this.state.dateQuery;
              newObject.fromDate= this.state.fromDate;
            
              this.setState({dateQuery: newObject});
            }

          }
    },
     //Handle Selecting ToDate
    handleToDateFieldChange: function(toDateVal) {
      var newObject=[];
      if(toDateVal.length===0)
      {
        this.setState({toDate:null, activities:[]});
      }
      else{
          this.state.toDate = new Date(toDateVal).getTime()/ 1000;
          this.state.toDate = this.state.toDate/60/60/24;

          if(!!this.state.eventQuery.eventName)
            {
              newObject = this.state.eventQuery;
              newObject.toDate= this.state.toDate;
              this.setState({eventQuery: newObject});
            }
            else if(!!this.state.videoQuery.topic || !!this.state.videoQuery.language || !!this.state.videoQuery.country)
            {
              newObject = this.state.videoQuery;
              newObject.toDate= this.state.toDate;
            
            this.setState({videoQuery: newObject});
            }
            else if(!!this.state.organizationQuery.organization )
            {
              newObject = this.state.organizationQuery;
              newObject.toDate= this.state.toDate;

              this.setState({organizationQuery: newObject});
            }
            else if(!!this.state.userQuery.userdevice )
            {
              newObject = this.state.userQuery;
              newObject.toDate= this.state.toDate;

              this.setState({userQuery: newObject});
            }
            else if(!!this.state.locationQuery.fromLatitude ||!!this.state.locationQuery.toLatitude
              ||!!this.state.locationQuery.toLongitude ||!!this.state.locationQuery.fromLongitude)
            {
              newObject = this.state.locationQuery;
              newObject.toDate= this.state.toDate;
            
            this.setState({locationQuery: newObject});
            }
            else{
              newObject = this.state.dateQuery;
              newObject.toDate= this.state.toDate;
              this.setState({dateQuery: newObject});
            }
          
          }      
    },
     //Choose by Annimation- Handle Selecting Topic
    handleTopicFieldChange: function(topicVal) {
      const newObject = this.state.videoQuery;

      if(!topicVal)
      {

        newObject.topic= topicVal;

        this.setState({videoQuery: newObject,
         topicChanged:false,saveClicked:false,activities:[]});

         if((this.state.toDate!=null || this.state.fromDate!=null))
         {
          this.setState({saveClicked:false});
          this.setState({dateReset:true});
          }
      }
      else
      {
      newObject.topic = topicVal;
      this.setState({
        videoQuery: newObject,
      });
      this.setState({topicChanged:true});
    }
    },
    //Choose by Annimation- Handle Selecting Language
    handleLanguageFieldChange: function(languageVal) {
          const newObject = this.state.videoQuery;
          if(!languageVal)
          {
    
            newObject.language= languageVal;

            this.setState({videoQuery: newObject,languageChanged:false,saveClicked:false,activities:[]});

            if((this.state.toDate!=null || this.state.fromDate!=null))
            {
             this.setState({saveClicked:false});
             this.setState({dateReset:true});
             }
          }
          else
          {
          newObject.language = languageVal;
          this.setState({
            videoQuery: newObject,
          });
          this.setState({languageChanged:true});
        }
        },
     //Choose by Annimation- Handle Selecting Country
    handleCountryFieldChange: function(countryVal) {
      const newObject = this.state.videoQuery;

      if(!countryVal)
      {
        newObject.country= countryVal;

        this.setState({videoQuery: newObject, countryChanged:false,saveClicked:false,activities:[]});

        if((this.state.toDate!=null || this.state.fromDate!=null))
        {
         this.setState({saveClicked:false});
 
         this.setState({dateReset:true});
         }
      }
      else
      {
      newObject.country = countryVal;
      this.setState({
        videoQuery: newObject,
      });
      this.setState({countryChanged:true});
      }
    },
     //Choose by Organization- Handle Selecting Organization
     handleOrganizationFieldChange: function(organizationVal) {
      const newObject = this.state.organizationQuery;

      if(!organizationVal)
      {

        newObject.organization= organizationVal;

        this.setState({organizationQuery: newObject, organizationChanged:false, saveClicked:false,activities:[]});

        if((this.state.toDate!=null || this.state.fromDate!=null))
        {
         this.setState({saveClicked:false});
 
         this.setState({dateReset:true});
         }
      }
      else
      {
      newObject.organization = organizationVal;
      this.setState({
        organizationQuery: newObject,
      });
      this.setState({organizationChanged:true});
      }
    },
     //Choose by User- Handle Selecting userdevice
     handleUserFieldChange: function(userVal) {
      const newObject = this.state.userQuery;
      if(!userVal)
      {

        newObject.userdevice= userVal;

        this.setState({userQuery: newObject, userChanged:false,saveClicked:false,activities:[]});

        if((this.state.toDate!=null || this.state.fromDate!=null))
        {
         this.setState({saveClicked:false});
 
         this.setState({dateReset:true});
         }
      }
      else
      {
      newObject.userdevice = userVal;
      this.setState({
        userQuery: newObject,
      });
      this.setState({userChanged:true});
       }
    },
    handleTextFieldChange: function(textField, value){
      const newObject = this.state.locationQuery;

      if(!value)
      {
          newObject.fromLatitude = value;

          newObject.toLatitude = value;
 
          newObject.fromLongitude = value;

          newObject.toLongitude = value;

        
        this.setState({locationQuery: newObject, locationChanged:false,saveClicked:false,activities:[]});

        if((this.state.toDate!=null || this.state.fromDate!=null))
       {
        this.setState({saveClicked:false});

        this.setState({dateReset:true});
        }
      }
      else
      {
          if(textField==="fromLatitude")
          {
            newObject.fromLatitude = value;
          }
          else if(textField==="toLatitude")
          {
            newObject.toLatitude = value;
          }
          else if(textField==="fromLongitude")
          {
            newObject.fromLongitude = value;
          }
          else if(textField==="toLongitude")
          {
            newObject.toLongitude = value;
          }
          this.setState({
            locationQuery: newObject,
          });
          this.setState({locationChanged:true});
        }
    },   
      handleDownload: function(fileTypeVal) {

      this.setState({fileType: fileTypeVal});
      
     },
     //API call to get activity by Event
    getByEventName() {
      if(this.state.loading)
      {
        return API.get('activity', `/activity/getbyeventname`,{'queryStringParameters':this.state.eventQuery});        
      }
    },   
    //API call to get activity by videoId
    getByVideoId() {
      if(this.state.loading)
      {
        return API.get('activity', `/activity/getbyvideoid`,{'queryStringParameters':this.state.videoQuery});
      }
    },
     //API call to get activity by videoId
     getByOrganization() {
      if(this.state.loading)
      {
        return API.get('activity', `/activity/getbyorganization`,{'queryStringParameters':this.state.organizationQuery});
      }
    },  
     //API call to get activity by videoId
     getByUser() {
      if(this.state.loading)
      {
        return API.get('activity', `/activity/getbyuserdevice`,{'queryStringParameters':this.state.userQuery});
      }
    },   
     //API call to get activity by location
     getByLocation() {
      if(this.state.loading)
      {
        return API.get('activity', `/activity/getbylocation`,{'queryStringParameters':this.state.locationQuery});
      }
    },          
     //API call to get activity by daterange
     getByDateRange() {
      if(this.state.loading)
      {
        return API.get('activity', `/activity/getbytimestamp`,{'queryStringParameters':this.state.dateQuery});
      }
    },

    handleSubmit:  async function() {
      this.state.loading=true;
      this.setState({loading:true});
      var editField= false;
      
      if((this.state.eventChanged && this.state.topicChanged) || (this.state.eventChanged && this.state.languageChanged)|| (this.state.eventChanged && this.state.countryChanged)||
      (this.state.eventChanged && this.state.locationChanged) ||(this.state.eventChanged && this.state.organizationChanged) || (this.state.eventChanged && this.state.userChanged))
      {
        editField=true;

      }
      if((this.state.locationChanged && this.state.topicChanged) || (this.state.userChanged && this.state.topicChanged) 
      ||(this.state.topicChanged && this.state.organizationChanged) ||(this.state.topicChanged && this.state.locationChanged) )
      {
        editField =true;

      }
      if((this.state.locationChanged && this.state.languageChanged) || (this.state.userChanged && this.state.languageChanged) 
      ||(this.state.languageChanged && this.state.organizationChanged) ||(this.state.languageChanged && this.state.locationChanged) )
      {
        editField =true;

      }
      if((this.state.locationChanged && this.state.countryChanged) || (this.state.userChanged && this.state.countryChanged) 
      ||(this.state.countryChanged && this.state.organizationChanged) ||(this.state.countryChanged && this.state.locationChanged) )
      {
        editField =true;

      }
      if((this.state.locationChanged && this.state.userChanged) || (this.state.locationChanged && this.state.organizationChanged) )
            {
              editField =true;

      }
      if(this.state.organizationChanged && this.state.userChanged)
       {
         editField =true;
      }
  
      if(editField)
      {
        this.setState({multiParam:true});
      }
      else 
      {
        if(this.state.saveClicked)
        {
           this.setState({ reset: true });
        }
      

      if(this.state.toDate==null || this.state.fromDate==null)
      {
        this.setState({ open: true });
        this.setState({ loading: true });
      }
    else{
      if(!this.state.saveClicked &&(this.state.eventChanged || this.state.topicChanged || this.state.languageChanged || this.state.countryChanged
          || this.state.locationChanged || this.state.organizationChanged || this.state.userChanged)) /*try for empty activities*/
        {
           this.state.loading=true;
           this.setState({loading:true, saveClicked:true});
           this.componentDidMount();
       }

      }


  }

  },
   //reset input fields
  resetInput: function() {

    window.location.reload();
          
  },
  handleClose :function ()  {
    // this.setState({dateReset:false});
    this.setState({multiParam:false});
    // this.setState({saveClicked:true});
    // this.setState({ editField: false });

    this.setState({ loading: false });
  },
  handleDateResetClose :function ()  {
      this.setState({dateReset:false});
      this.setState({ loading: false });
    },
  handleEmptyClose:function(){
      this.setState({okayPressed:true});
      this.setState({ editField: false });
      this.setState({saveClicked:false});
      this.setState({ loading: false });
    },

    handleDateWarningClose:function(){
      this.setState({ open: false });
      this.setState({ loading: false });
    },
    handleResetClose:function(){
      this.setState({ reset: false });
      this.setState({ loading: false });
      this.setState({saveClicked:true});

    },

    /*Bar Graph*/ 
    
    barGraph: function(props) {
      return (
        <Button variant="contained" style={{marginLeft:20,backgroundColor:"#ffac33"}} onClick={props.onClick}>
        Bar Graph
      </Button>
      );
    },
    handleBarGraphClose:function(){
      this.setState({ bargraph: false });
    }, 
    handleBarGraphClick() {
    this.setState({bargraph: true});
  },
  /*Line Graph*/ 
    lineGraph: function(props) {
        return (
          <Button variant="contained" style={{marginLeft:20,backgroundColor:"#ffac33"}} onClick={props.onClick}>
          Line Graph
        </Button>
        );
      },
    handleLineGraphClick() {
        this.setState({linegraph: true});
    },
    handleLineGraphClose:function(){
      this.setState({ linegraph: false });
    }, 

     /*Pie Graph*/ 
     pieGraph: function(props) {
      return (
        <Button variant="contained" style={{marginLeft:20,backgroundColor:"#ffac33"}} onClick={props.onClick}>
        Pie Chart
      </Button>
      );
    },
  handlePieGraphClick() {
      this.setState({piegraph: true});
  },
  handlePieGraphClose:function(){
    this.setState({ piegraph: false });
  }, 

  /*Scatter Graph*/ 
     scatterGraph: function(props) {
      return (
        <Button variant="contained" style={{marginLeft:20,backgroundColor:"#ffac33"}} onClick={props.onClick}>
        Scatter Chart
      </Button>
      );
    },
  handleScatterGraphClick() {
      this.setState({scattergraph: true});
  },
  handleScatterGraphClose:function(){
    this.setState({ scattergraph: false });
  }, 

  async componentDidMount() {
    var self = this;
        if (!this.props.isAuthenticated) {
          return;
        }
        var activities=[];
        var newArray = [];
          try {
            if(!!this.state.eventQuery.eventName)
            {
                activities = await this.getByEventName();
                if(activities !==undefined && activities.length>0)
                {  for(var i in activities)
                  {
                      activities[i].items.map(function(activity){
                        // activity.where_shareEventLog[0]= parseFloat(activity.where_shareEventLog[0]);
                        // activity.where_shareEventLog[1]= parseFloat(activity.where_shareEventLog[1]);
                        // newArray.push(activity);
                        self.safePushLatLng(activity, newArray);
                      });
                      this.setState({ activities:newArray });
                      // this.setState({disableButton:true});

                  }   
                }
              }
            else if(!!this.state.videoQuery.topic || !!this.state.videoQuery.language || !!this.state.videoQuery.country)
              {
                activities = await this.getByVideoId();
                if(activities !==undefined  && activities.length>0)
                {  
                      activities.map(function(activity){
                        activity.items.forEach(function(t){
                        if(activity.items.length >0)
                          {
                            // t.where_shareEventLog[0]= parseFloat(t.where_shareEventLog[0]);
                            // t.where_shareEventLog[1]= parseFloat(t.where_shareEventLog[1]);
                            // newArray.push(t);
                            self.safePushLatLng(t, newArray);
                          }
                        });
                      });
                       this.setState({ activities:newArray });
                      //  this.setState({disableButton:true});

                }
              }
             else if(!!this.state.organizationQuery.organization)
              {
                   activities = await this.getByOrganization();
                  if(activities !==undefined  && activities.length>0)
                  {  
                        activities.map(function(activity){
                          // activity.where_shareEventLog[0]= parseFloat(activity.where_shareEventLog[0]);
                          // activity.where_shareEventLog[1]= parseFloat(activity.where_shareEventLog[1]);
                          // newArray.push(activity);
                          self.safePushLatLng(activity, newArray);
                        });
                        this.setState({ activities:newArray });
                        // this.setState({disableButton:true});

                }
               }
               else if(!!this.state.dateQuery.fromDate || !!this.state.dateQuery.toDate )
               {
                    activities = await this.getByDateRange();
                    activities.items.map(function(activity){
                      // activity.where_shareEventLog[0]= parseFloat(activity.where_shareEventLog[0]);
                      // activity.where_shareEventLog[1]= parseFloat(activity.where_shareEventLog[1]);
                      // newArray.push(activity);
                      self.safePushLatLng(activity, newArray);
                    });
                    this.setState({ activities:newArray });
                    // this.setState({disableButton:true});

                }
              else if(!!this.state.userQuery.userdevice)
               {
                activities = await this.getByUser();

                  activities.map(function(activity){
                    activity.items.forEach(function(t){
                    if(activity.items.length >0)
                      {
                        // t.where_shareEventLog[0]= parseFloat(t.where_shareEventLog[0]);
                        // t.where_shareEventLog[1]= parseFloat(t.where_shareEventLog[1]);
                        // newArray.push(t);
                        self.safePushLatLng(activity, newArray);
                      }
                    });
                  });
                  this.setState({ activities:newArray });
                  // this.setState({disableButton:true});

                }
                else if(!!this.state.locationQuery.fromLatitude ||!!this.state.locationQuery.toLatitude
                   ||!!this.state.locationQuery.toLongitude ||!!this.state.locationQuery.fromLongitude)
                {
                 activities = await this.getByLocation();
 
                   activities.map(function(activity){
                       {
                        activity.datestamp = parseFloat(activity.datestamp.N);
                        activity.when_shareEventLog= parseFloat(activity.when_shareEventLog.N);
                        activity.where_shareEventLog[0]= parseFloat(activity.where_shareEventLog.SS[0]);
                        activity.where_shareEventLog[1]= parseFloat(activity.where_shareEventLog.SS[1]);
                        activity.id= activity.id.S;
                        activity.vidId= activity.vidId.S;
                        activity.state= activity.state.S;
                        activity.country= activity.country.S;
                        activity.eventDuration= parseFloat(activity.eventDuration.N);
                        activity.eventName= activity.eventName.S;
                        activity.organization= activity.organization.S;
                        activity.userdevice= activity.userdevice.S;
                        activity.geoJson= activity.geoJson.S;
                        activity.geohash= activity.geohash.N;
                        activity.hashKey= activity.hashKey.N;
                        activity.rangeKey= activity.rangeKey.S;
                        activity.userdevice_datestamp= activity.userdevice_datestamp.S;
                        activity.vidTitle= activity.vidTitle.S;
                        activity.vidid_datestamp= activity.vidid_datestamp.S;
                        activity.eventName_datestamp= activity.eventName_datestamp.S;

                        activity.wifi= activity.wifi.BOOL;
                        activity.cellular= activity.cellular.BOOL;
                        newArray.push(activity);

                       }
                   });
                   this.setState({ activities:newArray });
                  //  this.setState({disableButton:true});

                 }
        
            this.setState({loading:false});

        } catch (e) {
          this.setState({loading:false});

          alert(e);
        }
      
  },
  render: function() {
    var { options, pieOptions,countData, pieGraph,tmpPie } = this.state;
    this.state.filteredItems = this.state.activities;


    if(this.state.activities.length>0 && this.state.loading)
    {

      this.state.activities.forEach(function(part, index) {
        // display Yes or No for boolean values
        var tmpgraph={date:'',event:''};

      if (!isString(part.datestamp))
      {

        if(part.wifi)
        {
          part.wifi = "Yes";
        }
        else 
        {
          part.wifi = "No";
        }

      if(part.cellular)
      {
        part.cellular = "Yes";
      }
      else 
      {
        part.cellular = "No";
      }
     

        tmpgraph.date=part.datestamp*1000*60*60*24;
        tmpgraph.event= part.eventName;
        
        graphArray.push(tmpgraph);

        //part.datestamp = dateConverter.getDate((part.datestamp*60*60*24));
        part.datestamp = dateConverter.getDate(part.datestamp); //* 24 * 60 * 60 * 1000
        part.when_shareEventLog =dateConverter.getDate((part.when_shareEventLog)); //*60*60*24
        part.where_shareEventLog = (part.where_shareEventLog[0]+" , " +part.where_shareEventLog[1]);
      }
      

      //  tmp.push(part.eventName);
       options.xaxis.categories.push(part.datestamp);


    });

        this.state.filteredItems=this.state.activities.sort((a,b) => a['datestamp']>b['datestamp']?1:-1);
        console.log("graphArray");
        console.log(graphArray);
      
      /**Find count of events per date
       * @returns array[date,count]
       **/
       

        tmpPie.push(graphArray.reduce(function (acc, curr) {
            if (typeof acc[curr.event] == 'undefined') {
              acc[curr.event] = 1;
              counter++;;
            } else {
              counter++;
              acc[curr.event] += 1;
            }

            return acc;
          }, {}));
       



      countData.push(graphArray.reduce(function (acc, curr) {

        if (typeof acc.date =='undefined' &&  typeof acc.event =='undefined') {
          acc.date = curr.date;
          acc.count= 1;
          acc.event= curr.event;
          counter++;
        } else if(acc.event == curr.event && acc.date == curr.date){
          counter++;
          acc.count+=1;
        }else if(acc.date != curr.date) {
          countData.push(acc);
          acc=[];
          acc.date = curr.date;
          acc.count= 1;
          acc.event= curr.event;
          counter++;
        }

        return acc;
      }, {}));

      graphArray=[];
    }

      if(counter>0 && !this.state.loading)
      {
          for(var i=0; i< tmpPie.length; i++)
          {
            pieOptions.labels.push(Object.keys(tmpPie[i]));
            pieOptions.series.push(tmpPie[i][Object.keys(tmpPie[i])]);

          }
        
          console.log("pieOptions");
          console.log(pieOptions);
                
            for(var i=0; i< this.state.countData.length; i++)
            {
      
              if(this.state.options.series.length==0)
              {
                var eventArray={name:'',data:[[]]};
      
                eventArray.name= this.state.countData[i].event;
                eventArray.data[0].push(this.state.countData[i].date);
                eventArray.data[0].push(this.state.countData[i].count);
                this.state.options.series.push(eventArray);
      
              }
              else 
              { 
                for(var item in this.state.options.series)
                {
                  if (this.state.options.series.some(el => this.state.countData[i].event === el.name))
                  {
                    if(this.state.options.series[item].name == this.state.countData[i].event )
                    {
                      var eventArray=[];
      
                      eventArray.push(this.state.countData[i].date);
                      eventArray.push(this.state.countData[i].count);
                      this.state.options.series[item].data.push(eventArray);
                    }
                  }         
                  else 
                  {
                    var eventArray={name:'',data:[[]]};
      
                    eventArray.name= this.state.countData[i].event;
                    eventArray.data[0].push(this.state.countData[i].date);
                    eventArray.data[0].push(this.state.countData[i].count);
                    this.state.options.series.push(eventArray);
      
                  }
                }
              }
      
            }
            this.state.countData=[];
            counter = 0;
            console.log("series");
            console.log(this.state.options.series);
      }
    
    return (

          <Paper>

          <FormLabel style={styles.header}>View Data</FormLabel>
 
              {/* <GoogleMapsContainer /> */}
              
            {/* <Paper style={{marginBottom:20}}>
              <Grid container spacing={24}>
                <Grid item xs={2} >
                  <Button style={{marginLeft:20,backgroundColor:"#ffac33"}} onClick={this.handleBarGraphClick}>
                    Bar Graph
                  </Button>
                </Grid>
                <Grid item xs={2} >
                  <Button style={{backgroundColor:"#ffac33"}} onClick={this.handleLineGraphClick}>
                      Line Graph
                    </Button>
                </Grid>
                <Grid item xs={2} >
                  <Button style={{backgroundColor:"#ffac33"}} onClick={this.handlePieGraphClick}>
                    Pie Graph
                  </Button>
                </Grid>
                <Grid item xs={2} >
                  <Button style={{backgroundColor:"#ffac33"}}  onClick={this.handleScatterGraphClick}>
                    Scatter Plot
                  </Button>
                  </Grid>
                <Grid item xs={2} >
                  <Button  style={{backgroundColor:"#ffac33"}}>
                      Web Point Map
                  </Button>
                </Grid>
             </Grid>
           </Paper> */}


             {/* <GoogleMapsContainer /> */}
             
          <Grid container spacing={24}>

             <Card style={{margin: 20, width: 300}}>
                    <FormLabel style={{ marginLeft:110}}>Event Options</FormLabel>
             <EventView onChange={this.handleEventChange} />
             </Card>

              <GoogleMapsContainer
                  events={this.state.filteredItems}
                  googleMapURL={`https://maps.googleapis.com/maps/api/js?key=`+config.googleMap.GOOGLE_API_KEY+`&v=3.exp&libraries=geometry,drawing,places`}
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ marginaLeft:20, height: `600px`, width: `750PX` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                  style={{marginaLeft:20}}
                />
          </Grid>      
          <Grid container spacing={24}>
              <Card style={{margin: 20, width: 350}}>
                <FormLabel style={{ marginLeft:110}}>Annimations</FormLabel>
                  <VideoTopicSelect onChange={this.handleTopicFieldChange}/>
                  <VideoLanguageSelect onChange={this.handleLanguageFieldChange}/>
                  <VideoCountrySelect onChange={this.handleCountryFieldChange}/>
              </Card>

                 <Card style={{margin: 20, width: 300}}>
                    <FormLabel style={{ marginLeft:110}}>Location</FormLabel>
                       <CoordinateSelect onChange={this.handleTextFieldChange}/>
                 </Card>  


                  <Card style={{margin: 20, width: 300}}>
                      <FormLabel style={{ marginLeft:110}}>Organization</FormLabel>
                        <OrganizationSelect onChange={this.handleOrganizationFieldChange}/>
                  </Card>
                

                 <Card style={{margin: 20, width: 300}}>
                    <FormLabel style={{ marginLeft:110}}>User</FormLabel>
                      <UserSelect onChange={this.handleUserFieldChange}/>
                 </Card>   

                 <Card style={{margin: 20, width: 350}}>
                    <FormLabel style={{ marginLeft:110}}>X-axis Options</FormLabel>

                      <FromDate  onChange={this.handleFromDateFieldChange} />
                      <ToDate  onChange={this.handleToDateFieldChange} />
                 </Card>          
            
                         {/* <DialogSelect onChange={this.handleDownload}/>  */}
                        
         <Card style={{margin: 20, width: 300}}>
            <FormLabel style={{ marginLeft:110}}>Export Options</FormLabel>
           {/* if(this.state.fileType == ".cvs") */}
              <CSVLink data={this.state.filteredItems} headers={TABLE_COLUMNS}   filename={currentTime+" activity_Table.csv"}>
              <button className="btn btn-sm btn-primary" style={{margin:10}}>Download .cvs</button>
              </CSVLink>
            
              <Workbook  filename={currentTime+" activity_Table.xlsx"} element={<button className="btn btn-sm btn-primary" style={{margin:10}}>Download .xlsx</button>}>
                <Workbook.Sheet data={this.state.filteredItems}  name="Sheet A" >
                  <Workbook.Column label= "id" value="id"/>
                  <Workbook.Column label= "vidId" value="vidId"/>
                  <Workbook.Column label= "cellular" value="cellular"/>
                  <Workbook.Column label= "state" value="state"/>
                  <Workbook.Column label= "country" value="country"/>
                  <Workbook.Column label= "datestamp" value="datestamp"/>
                  <Workbook.Column label= "eventDuration" value="eventDuration"/>
                  <Workbook.Column label= "event" value="eventName"/>
                  <Workbook.Column label= "organization" value="organization"/>
                  <Workbook.Column label= "Viewed on wifi" value="wifi"/>
                  <Workbook.Column label= "user" value="userdevice"/>
                  <Workbook.Column label= "when_shareEventLog" value="when_shareEventLog"/>
                  {/* <Workbook.Column label= "where_shareEventLog" value="where_shareEventLog"/> */}
                  <Workbook.Column
                    label="where_shareEventLog"
                    value={row => typeof row.where_shareEventLog === 'string'
                      ? row.where_shareEventLog
                      : (Array.isArray(row.where_shareEventLog)
                          ? row.where_shareEventLog.join(', ')
                          : 'N/A')}
                  />
                </Workbook.Sheet>
              </Workbook> 
        </Card> 
        
        <Card style={{margin: 20, width: 300}}>
          <FormLabel style={{ marginLeft:110}}>Additional Options</FormLabel>
                  <button className="btn btn-sm btn-primary"
                  onClick={this.resetInput}
                  style={{margin: 10}}>
                  Reset Parameters
                  </button>
          </Card> 

           <LoaderButton
                  block
                  bsStyle="primary"
                  bsSize="large"
                  onClick={this.handleSubmit}
                  disabled={this.state.disableButton}
                  text="Save All Parameters"
                  loadingText="Processing..."
                  isLoading={this.state.loading}
                />
        </Grid>

        {/* BAR GRAPH*/ }

        <BarGraph
                        open={this.state.bargraph}
                        options={this.state.options}
                        onClick={this.handleBarGraphClose}
                    />
         {/* LINE GRAPH*/ }

        <LineGraph
                        open={this.state.linegraph}
                        options={this.state.options}
                        onClick={this.handleLineGraphClose}
                    />
        
         {/* PIE GRAPH*/ }

         <PieGraph
                        open={this.state.piegraph}
                        options={this.state.pieOptions}
                        onClick={this.handlePieGraphClose}
                    />
        {/* SCATTER GRAPH*/ }

         <ScatterGraph
                        open={this.state.scattergraph}
                        options={this.state.options}
                        onClick={this.handleScatterGraphClose}
                    />
        

{/**warning Messages */}
        <Dialog
          open={this.state.open}
          onClose={this.handleDateWarningClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Empty Dates"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            Date cannot be empty. Please enter a valid date.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDateWarningClose} color="primary">
              Okay
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.reset}
          onClose={this.handleResetClose}
          aria-labelledby="alert-dialog-title-reset"
          aria-describedby="alert-dialog-description-reset"
        >
          <DialogTitle id="alert-dialog-title-reset">{"Reset Parameters"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description-reset">
            You can only query one parameter at a time.<br/>
             Please reset Parameters and the Date before you run the query again.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleResetClose} color="primary">
              Okay
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.dateReset}
          onClose={this.handleDateResetClose}
          aria-labelledby="alert-dialog-title-reset"
          aria-describedby="alert-dialog-description-reset"
        >
          <DialogTitle id="alert-dialog-title-reset">{"Reset Date"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description-reset">
            Please reset Date before you query<br/>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDateResetClose} color="primary">
              Okay
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.multiParam}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title-edit"
          aria-describedby="alert-dialog-description-edit"
        >
          <DialogTitle id="alert-dialog-title-edit">{"Choose One Parameter"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description-edit">
            You can only query one parameter at a time.<br/>
            Please choose only one of the following:<br/><br/>
            Event Options<br/>
            Annimations<br/>
            Locations<br/>
            Organization<br/>
            User<br/>
       
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Okay
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.loading && !this.state.eventChanged && !this.state.topicChanged && !this.state.languageChanged && !this.state.countryChanged
             && !this.state.locationChanged && !this.state.organizationChanged && !this.state.userChanged
            }
          onClose={this.handleEmptyClose}
          aria-labelledby="alert-dialog-title-empty"
          aria-describedby="alert-dialog-description-empty"
        >
          <DialogTitle id="alert-dialog-title-edit">{"Empty Fields"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description-empty">
            The parameter fields cannot be empty. Please enter a value to query.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleEmptyClose} color="primary">
              Okay
            </Button>
          </DialogActions>
        </Dialog>

              <DataTables
                  height={'auto'}
                  selectable={false}
                  showRowHover={false}
                  columns={TABLE_COLUMNS}
                  data={this.state.filteredItems}
                  showCheckboxes={false}
                  multiSelectable={false}
                  showHeaderToolbar={false}
                  // onRowSizeChange={this.handleRowSizeChange}
                  //  onCellClick={this.handleCellClick}
                  // onCellDoubleClick={this.handleCellDoubleClick}
                  tableBodyStyle={styles.tableBodyStyle}
                  tableStyle={styles.tableStyle}
                  tableWrapperStyle={styles.tableWrapperStyle}
                  rowSizeLabel={""}
                  rowSizeList	={[]} />
      </Paper>

        )
    }
  
  });

export default ActivityView;
